<script>
    import Chart from "./Chart.svelte";

    import { bar } from "./bar.js";

    let isMenuVisibile = false;
    let month = "Apr 2021";

    let months = [
        "Oct 2020",
        "Nov 2020",
        "Dec 2020",
        "Jan 2021",
        "Feb 2021",
        "Mar 2021",
        "Apr 2021",
    ];

    let index = months.indexOf(month);

    let k = {
        resource: ["Power", "Water", "Nitrogen", "Diesel"],
        unit: [
            "Chiller",
            "AHU",
            "Air Compressor",
            "Lighting",
            "2 Wheeler",
            "PSMT",
            "4 Wheeler",
            "Molding",
            "FU12 - Molding",
            "FU12 - ASSY",
            "SMT - Line 1",
            "SMT - Line 2",
            "2 W - ELECT",
        ],
    };
    function toggleMenu() {
        isMenuVisibile = isMenuVisibile ? false : true;
    }
    function selectMonth(e, i) {
        index = i;
        month = months[i];
        isMenuVisibile = false;
    }

    function previous() {
        index = months.indexOf(month);
        if (index > 0) {
            month = months[index - 1];
            index = index - 1;
        }
        isMenuVisibile = false;
    }
    function next() {
        index = months.indexOf(month);
        if (index < months.length - 1) {
            month = months[index + 1];
            index = index + 1;
        }
        isMenuVisibile = false;
    }
</script>

<aside
    class="fixed w-1/6 bg-gray-700 space-y-2 text-white px-4 text-xs 2xl:text-sm h-full overflow-y-auto"
>
    <div class="text-xl" style="margin-left:-1rem;">Consumption</div>
    <div class="text-lg text-red-400">Resource-wise</div>
    {#each k.resource as item}
        <div class="px-4 hover:bg-gray-900"><a href=".">{item}</a></div>
    {/each}
    <div class="text-lg text-red-400">Unit-wise</div>
    {#each k.unit as item}
        <div class="px-4 hover:bg-gray-900"><a href=".">{item}</a></div>
    {/each}
</aside>

<div class="flex w-full h-full">
    <aside class="w-1/6 flex flex-col" />
    <div class="w-5/6 flex flex-col">
        <div class="p-4">
            <button
                on:click={previous}
                class="text-xl rounded px-3 text-white {index == 0
                    ? 'cursor-not-allowed bg-gray-200 focus:outline-none'
                    : 'bg-gray-600'}">&lt;</button
            >
            <button
                class="text-xl rounded bg-gray-600 px-3 text-white"
                on:click={toggleMenu}>{month}</button
            >
            <button
                on:click={next}
                class="text-xl rounded px-3 text-white {index ==
                months.length - 1
                    ? 'cursor-not-allowed bg-gray-200 focus:outline-none'
                    : 'bg-gray-600'}">&gt;</button
            >

            <div class={isMenuVisibile ? "" : "hidden relative"}>
                <div class="bg-gray-400 z-10 absolute text-center w-48">
                    {#each months as mth, i}
                        <div
                            on:click={(e) => selectMonth(e, i)}
                            class="hover:bg-red-400 hover:text-white cursor-pointer"
                        >
                            {mth}
                        </div>
                    {/each}
                </div>
            </div>
        </div>

        <div style="height:90vh">
            <Chart option={bar} {month} />
        </div>
    </div>
</div>
